import React from 'react'

const AppIcon = ({ size = 48, style = {} }) => {
  return (
    <img 
      src="./logo.png" 
      alt="Etiquetando Logo" 
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        display: 'block',
        margin: '0 auto',
        ...style
      }}
      onError={(e) => {
        console.error('Erro ao carregar logo.png')
        // Se falhar, mostrar um placeholder
        e.target.style.backgroundColor = 'rgba(255,255,255,0.2)'
        e.target.style.border = '2px solid rgba(255,255,255,0.5)'
        e.target.style.borderRadius = '8px'
        e.target.alt = 'Logo não disponível'
      }}
      onLoad={() => {
        //console.log('Logo carregado com sucesso')
      }}
    />
  )
}

export default AppIcon